import * as Handlebars from "handlebars";
import "../../common/common-helpers";
import * as moment from 'moment-timezone';
require('identicon');
require('pnglib');
const md5 = require('md5');
import callingcode from 'callingcodewithdefaultcountry';

Handlebars.registerHelper('contacticon', function (s, options) {
    const settings = options.hash || {};
    var id;
    if (!settings.class) settings.class = "profileiconsmall";
    if (!settings.gravatarclass) settings.gravatarclass = "";
    if (s.firstName || s.lastName) {
        var colorClassId;
        if (s.firstName || s.lastName) {
            colorClassId = s.firstName + s.lastName;
            var n = (s.lastName ? s.lastName : "") + (s.firstName ? s.firstName : "");
            n = n.toLowerCase();
            id = n.substring(0, 1).normalize("NFD").substring(0, 1).toUpperCase();
            if (n.length > 1) {
                id += n.substring(1, 2).normalize("NFD").substring(0, 1);
            }
        } else { //msisdn
            colorClassId = s.msisdn;
            id = s.msisdn.substr(s.msisdn.length - 2, 2);
        }
        return new Handlebars.SafeString(`<div class='${settings.class} fg-black bgg-${Handlebars.helpers["tilecolorclass"](colorClassId)}'>${id}</div>`);
    } else { //email
        var email = s.email || s.msisdn;
        var imageSrc;
        if (settings.gravatar) {
            if (!settings.backup) settings.backup = 'identicon';
            imageSrc = gravatar(email || "", settings);
        } else {
            let options = {
                background: [255, 255, 255, 255],
                margin: 0,
                size: settings.size || 80
            };
            var data = new Identicon(Identicon.prototype.createHashFromString(email), options).toString();
            imageSrc = 'data:image/png;base64,' + data;
        }
        return new Handlebars.SafeString(`<div class='${settings.class}'><img src='${imageSrc}' class='${settings.gravatarclass}'/></div>`);
    }
});

//https://github.com/mazondo/gravatarjs
function gravatar(email, options) {
    //check to make sure you gave us something
    let opts = options || {},
        base,
        params = [];
    //set some defaults, just in case
    opts = {
        size: opts.size || "80",
        rating: opts.rating || "g",
        secure: opts.secure || (location.protocol === 'https:'),
        backup: opts.backup || ""
    };
    //setup the email address
    email = email.trim().toLowerCase();
    //determine which base to use
    base = opts.secure ? 'https://secure.gravatar.com/avatar/' : 'http://www.gravatar.com/avatar/';
    //add the params
    if (opts.rating) {
        params.push("r=" + opts.rating);
    }
    if (opts.backup) {
        params.push("d=" + encodeURIComponent(opts.backup));
    }
    if (opts.size) {
        params.push("s=" + opts.size);
    }
    //now throw it all together
    return base + md5(email) + "?" + params.join("&");
}

Handlebars.registerHelper('reltimestamp', function (timestamp) {
    if (timestamp === undefined) {
        return "";
    } else {
        const date = new Date(timestamp);
        return new Handlebars.SafeString(toDate(date, {relative: true}));
    }
});

function toDate(date, options) {
    date = moment.utc(date);

    var localeDate = date.local();
    var formatedDate;
    if (options.relative) {
        formatedDate = localeDate.fromNow();
    }
    else if (options.format) {
        formatedDate = localeDate.format(options.format);
    }

    return new Handlebars.SafeString(formatedDate);
}

Handlebars.registerHelper('tilecolorclass', function (id) {
    if (!id) {
        return tellodyLightClasses[Math.floor((Math.random() * tellodyLightClasses.length))];
    }
    if (id.length === undefined) {
        id = "" + id;
    }
    const crc = FindCRC(id, id.length);
    const i = crc % tellodyLightClasses.length;
    const bgclass = tellodyLightClasses[i];
    return new Handlebars.SafeString(bgclass);
});

const FindCRC = function (data, datalen) {
    let i, j;
    let c;
    let CRC = 0;
    const genPoly = 0x07;
    for (j = 0; j < datalen; j++) {
        c = data.charCodeAt(j);
        CRC ^= c;
        for (i = 0; i < 8; i++)
            if (CRC & 0x80)
                CRC = (CRC << 1) ^ genPoly;
            else
                CRC <<= 1;
        CRC &= 0xff;
    }
    return CRC;
};

const tellodyLightClasses = [
    "boldPeach",
    "zanteBlue",
    "marineGreen",
    "barbieMauve",
    "mickeyPink",
    "ripeSquash",
    "timidFuchsia",
    "priceyEmerald",
    "freshCabbage",
    "lightBrick"
];

Handlebars.registerHelper('countryflagclass', function (phonenum) {
    phonenum = phonenum || "";
    /*Due to the i18n library works only with "+" and not the "00"
             if the user defines a number with "00" we remove them and we append the sign "+"
             */
    if (phonenum.indexOf("00") == 0) {
        phonenum = "+" + phonenum.substring(2);
    }
    if (phonenum.length) {
        try {
            const parsedPhoneNum = callingcode.parseAndKeepRawInput(phonenum);
            const countrycode = callingcode.getRegionCodeForNumber(parsedPhoneNum);
            const numberType = callingcode.getNumberType(parsedPhoneNum, countrycode);
            if (countrycode && (numberType == 1 || numberType == 2))
                return new Handlebars.SafeString(
                    `<i id='countryFlag' class='flag-icon flag-icon-${countrycode.toLowerCase()}'></i>` +
                    `<span id='country-code'> ${countrycode} </span>`);
        }
        catch (e) {
            console.info(`Unable to get region code for number: ${phonenum}`, e);
        }
        return new Handlebars.SafeString("<i id='countryFlag' class='icon-warning fg-darkRed'></i><span id='country-code'></span>");
    } else {
        return new Handlebars.SafeString("<i id='countryFlag'></i><span id='country-code'></span>");
    }

});

Handlebars.registerHelper('dateString', function (dateString, format) {
    if (dateString == undefined) {
        return "";
    }

    var date = moment(dateString, "YYYY-MM-DD");

    return new Handlebars.SafeString(toDate(date, {format: format}));
});